var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMissedPenalty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "13.23 9.77 12.47 9.77 12.47 15.27 12.47 15.79 12.47 21.51 12.47 22.03 12.47 26.92 12.32 26.92 11.62 26.92 9.57 26.92 9.57 24.95 9.57 24.86 9.57 18.69 9.57 18.61 9.57 12.44 9.57 12.35 9.61 12.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.49,
    y1: 9.77,
    x2: 18.48,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.75,
    y1: 9.77,
    x2: 24.73,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.01,
    y1: 9.77,
    x2: 34.99,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.25,
    y1: 9.77,
    x2: 41.24,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.87,
    y1: 13.4,
    x2: 45.87,
    y2: 11.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.87,
    y1: 19.66,
    x2: 45.87,
    y2: 17.65,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.87,
    y1: 25.9,
    x2: 45.87,
    y2: 23.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61,
    y1: 18.65,
    x2: 9.57,
    y2: 18.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61,
    y1: 24.9,
    x2: 9.57,
    y2: 24.86,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61,
    y1: 12.4,
    x2: 9.57,
    y2: 12.44,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61,
    y1: 18.65,
    x2: 9.57,
    y2: 18.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.57,
    y1: 26.84,
    x2: 9.5,
    y2: 26.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61,
    y1: 24.9,
    x2: 9.57,
    y2: 24.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.87,
    y1: 17.65,
    x2: 45.87,
    y2: 13.4,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.87 25.9 45.87 26.92 42.98 26.92 42.98 26.8 42.98 23 42.98 20.54 42.98 16.76 42.98 14.29 42.98 10.5 42.98 9.77 42.25 9.77",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.87,11.39V8.32a1.44,1.44,0,0,0-1.45-1.44H11A1.44,1.44,0,0,0,9.57,8.32v4l0,.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.48,
    y1: 9.77,
    x2: 13.23,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.73,
    y1: 9.77,
    x2: 19.49,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.99,
    y1: 9.77,
    x2: 25.75,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.24,
    y1: 9.77,
    x2: 36.01,
    y2: 9.77,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.87,
    y1: 23.9,
    x2: 45.87,
    y2: 19.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.98,
    y1: 26.8,
    x2: 42.86,
    y2: 26.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.68,
    cy: 43,
    r: 4.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.92,
    y1: 47.89,
    x2: 31.45,
    y2: 47.89,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.98,
    y1: 26.92,
    x2: 51.39,
    y2: 26.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.47,
    y1: 13.91,
    x2: 42.92,
    y2: 13.91,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.47,
    y1: 18.16,
    x2: 42.92,
    y2: 18.16,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.47,
    y1: 22.41,
    x2: 42.92,
    y2: 22.41,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.99,
    y1: 9.77,
    x2: 16.99,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.27,
    y1: 9.77,
    x2: 21.27,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.55,
    y1: 9.77,
    x2: 25.55,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.82,
    y1: 9.77,
    x2: 29.82,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1,
    y1: 9.77,
    x2: 34.1,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.38,
    y1: 9.77,
    x2: 38.38,
    y2: 26.86,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.98,
    y1: 35.67,
    x2: 51.39,
    y2: 35.67,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.21 29.61 44.68 27.37 34.91 38.36 32.02 35.8 41.79 24.8 39.26 22.55 45.04 20.05 50.81 17.56 49.01 23.58 47.21 29.61",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: "2.11558452044369px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedPenalty);
export default __webpack_public_path__ + "static/media/MISSED_PENALTY.86afcb60654543ea1fc13306fe469f3e.svg";
export { ForwardRef as ReactComponent };